// /perfil — Perfil con puntos reales + navegación a sub-páginas FASE 2
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight, Star } from 'lucide-react';
import { COLORS } from './designSystem';
import { getStoredAge } from './userStore';
import { BottomNav, PhoneShell } from './components';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ProfilePage() {
  const navigate = useNavigate();
  const [me, setMe] = useState(null);
  const [age, setAge] = useState(getStoredAge() || 18);

  useEffect(() => {
    const token = localStorage.getItem('user_token');
    if (!token) { setMe({ guest: true, name: 'Clubbers Member' }); return; }
    fetch(`${API}/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.ok ? r.json() : null)
      .then((d) => setMe(d ? { ...d, guest: false } : { guest: true, name: 'Clubbers Member' }))
      .catch(() => setMe({ guest: true, name: 'Clubbers Member' }));
    const onAge = () => setAge(getStoredAge() || 18);
    window.addEventListener('clubbers:age-change', onAge);
    return () => window.removeEventListener('clubbers:age-change', onAge);
  }, []);

  const puntos = me?.points || 0;
  const target = me?.golden_threshold || 1000;
  const pct = Math.min(100, (puntos / target) * 100);
  const name = me?.name || 'Clubbers Member';

  const rows = [
    { label: 'Mi edad', sub: `+${age} · solo ves eventos a los que puedes entrar`, to: '/perfil/edad', tid: 'profile-row-edad' },
    { label: 'Mis entradas', sub: '', to: '/entradas', tid: 'profile-row-entradas' },
    { label: 'Salas guardadas', sub: '', to: '/perfil/guardadas', tid: 'profile-row-guardadas' },
    { label: 'Ajustes', sub: '', to: '/perfil/ajustes', tid: 'profile-row-ajustes' },
  ];

  return (
    <PhoneShell>
      <header className="px-5 pt-6 pb-4">
        <h1 className="text-white text-2xl font-extrabold mb-5">Perfil</h1>
        <div className="flex items-center gap-4 mb-6">
          <div className="w-16 h-16 rounded-full flex items-center justify-center text-xl font-extrabold" style={{ backgroundColor: COLORS.surface, border: `1px solid ${COLORS.border}`, color: COLORS.text }}>{name.charAt(0).toUpperCase()}</div>
          <div>
            <h2 className="text-white text-lg font-extrabold" data-testid="profile-name">{name}</h2>
            <p className="text-sm" style={{ color: COLORS.textMuted }}>Madrid</p>
          </div>
        </div>
        <div className="rounded-[24px] p-5 mb-5 relative overflow-hidden" style={{ backgroundColor: COLORS.primary }} data-testid="profile-points-card">
          <div className="flex items-start justify-between">
            <div className="flex items-center gap-2">
              <Star size={20} fill="#fff" color="#fff" />
              <span className="text-white font-extrabold tracking-wide">CLUBBERS {me?.tier || 'MEMBER'}</span>
            </div>
            <span className="text-white text-3xl font-extrabold tracking-tight" data-testid="profile-points">{puntos} pts</span>
          </div>
          <div className="mt-5">
            <div className="flex items-center justify-between text-[11px] text-white/80 mb-1.5">
              <span>Progreso a Golden</span><span>{puntos}/{target}</span>
            </div>
            <div className="h-1 rounded-full bg-white/20 overflow-hidden">
              <div className="h-full bg-white" style={{ width: `${pct}%` }} />
            </div>
          </div>
          <p className="text-xs mt-4 text-white/80 leading-relaxed">Gana puntos con cada entrada y canjéalos por copas, entradas y descuentos.</p>
        </div>
        <div className="space-y-2">
          {rows.map((r) => (
            <button key={r.label} onClick={() => navigate(r.to)} className="w-full flex items-center justify-between p-4 rounded-2xl text-left" style={{ backgroundColor: COLORS.surface, border: `1px solid ${COLORS.border}` }} data-testid={r.tid}>
              <div>
                <p className="text-white font-semibold text-[15px]">{r.label}</p>
                {r.sub && <p className="text-xs mt-0.5" style={{ color: COLORS.textMuted }}>{r.sub}</p>}
              </div>
              <ChevronRight size={18} color={COLORS.textMuted} />
            </button>
          ))}
        </div>
      </header>
      <BottomNav />
    </PhoneShell>
  );
}
